<h1 mat-dialog-title>{{'Report URL' | translate}}</h1>
<div mat-dialog-content class="report-url-dialog-content">
    <div class="mat-field-with-button">
        <mat-form-field floatLabel="always">
            <input #reportUrlInput
                    matInput
                    id="reportUrl"
                    [value]="reportUrl"
                    class="like-input"
                    readonly>
        </mat-form-field>
        <button *ngIf="!isCopied"
                mat-button
                [color]=" 'primary'"
                (click)="copy(reportUrlInput)"
                cdkFocusInitial
                class="mxs-button mxs-button--primary">Copy
        </button>
        <button *ngIf="isCopied"
                mat-raised-button
                [color]=" 'primary'"
                (click)="copy(reportUrlInput)"
                cdkFocusInitial
                class="mxs-button mxs-button--primary">Copied
        </button>
    </div>
    <div *ngIf="data.headerAuth === true" class="mx-report-url-auth-instructions">
        <p>{{'Authenticate the request by adding your API key as an HTTP header:' | translate}}</p>
        <pre class="mx-report-url-usage">X-API-Key: &lt;YOUR_API_KEY&gt;</pre>
        <p class="mx-report-url-hint">
            {{'Generate or rotate your key from Profile -> API Key.' | translate}}
        </p>

        <p class="mx-report-url-section-label">{{'Example with curl:' | translate}}</p>
        <div class="mx-report-url-curl-row">
            <textarea #curlInput
                      class="like-input mx-report-url-curl"
                      readonly
                      rows="2">{{curlExample}}</textarea>
            <button mat-icon-button
                    type="button"
                    [matTooltip]="curlCopied ? ('Copied' | translate) : ('Copy curl example' | translate)"
                    (click)="copyCurl(curlInput)">
                <mat-icon>{{curlCopied ? 'check' : 'content_copy'}}</mat-icon>
            </button>
        </div>

        <p class="mx-report-url-fallback">
            <strong>{{'Basic authentication is still supported.' | translate}}</strong>
            {{'Bots using the legacy Authorization: Basic <(username:password)> in base64 header will keep working, but expire whenever the password is rotated. Switching to the API key avoids those interruptions.' | translate}}
        </p>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button class="mxs-button mxs-button--secondary"
            [mat-dialog-close]="false">{{'Close' | translate}}
    </button>
</div>
